<ng-container
  *ngIf="customTemplate"
  [ngTemplateOutlet]="customTemplate">
</ng-container>
